import keyMirror from 'helpers/keymirror';

enum CALENDER_EVENTS_ACTION_KEYS {
  GET_SUMMARY = 'CALENDER_EVENTS/GET_SUMMARY',
}

const actions = {
  [CALENDER_EVENTS_ACTION_KEYS.GET_SUMMARY]: null,
};

const actionTypes = keyMirror(actions);

export { CALENDER_EVENTS_ACTION_KEYS };
export default actionTypes;
